import { NgModule } from "@angular/core";
import { Apollo } from "apollo-angular";
import { environment } from "../environments/environment";
import { AuthenticationService } from './../services/authentication.service';
import { InMemoryCache } from '@apollo/client/core';

@NgModule({
})
export class GraphQLModule {
    private readonly accountApi = environment.AccountApiHost;
    private readonly cloudApi = environment.CloudApiHost;

    constructor(
        private _apollo: Apollo,
        private _authService: AuthenticationService
    ) {

        this._apollo.createNamed("account", {
            link: this._authService.createApolloLink(this.accountApi),
            cache: new InMemoryCache(),
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: "no-cache",
                },
                query: {
                    fetchPolicy: "no-cache",
                },
                mutate: {
                    fetchPolicy: "no-cache",
                },
            },
        });

        this._apollo.createNamed("cloud", {
            link: this._authService.createApolloLink(this.cloudApi),
            cache: new InMemoryCache(),
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: "no-cache",
                },
                query: {
                    fetchPolicy: "no-cache",
                },
                mutate: {
                    fetchPolicy: "no-cache",
                },
            },
        });

    }
}
